 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import TEXTLOVE from '@/components/Text/love'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTINTRODUCTION from '@/components/Text/introduction'
 import TEXT01_SECTION from '@/components/Text/01_section'
 import TEXT02_NOTE from '@/components/Text/02_note'
 import TEXT03_SERIES from '@/components/Text/03_series'
 import TEXT04_DED from '@/components/Text/04_ded'
 import TEXT05_PART1 from '@/components/Text/05_part1'
 import TEXT06_PART2 from '@/components/Text/06_part2'
 import TEXT07_PART3 from '@/components/Text/07_part3'
 import TEXT08_PART4 from '@/components/Text/08_part4'
 import TEXT09_WORKPOINTS from '@/components/Text/09_workpoints'
 import TEXT10_NOTESINTHETEXT from '@/components/Text/10_notesinthetext'
 import TEXT11_SECTION02 from '@/components/Text/11_section02'
 import TEXT12_DEDICAT from '@/components/Text/12_dedicat'
 import TEXT13_SERIES from '@/components/Text/13_series'
 import TEXT14_PART1 from '@/components/Text/14_part1'
 import TEXT15_II from '@/components/Text/15_II'
 import TEXT16_III from '@/components/Text/16_III'
 import TEXT17_IV from '@/components/Text/17_IV'
 import TEXT18_V from '@/components/Text/18_V'
 import TEXT19_PART2VI from '@/components/Text/19_part2VI'
 import TEXT20_VII from '@/components/Text/20_VII'
 import TEXT21_VIII from '@/components/Text/21_VIII'
 import TEXT22_IX from '@/components/Text/22_IX'
 import TEXT23_PART3X from '@/components/Text/23_part3X'
 import TEXT24_XI from '@/components/Text/24_XI'
 import TEXT25_PART4XII from '@/components/Text/25_part4XII'
 import TEXT26_XIII from '@/components/Text/26_XIII'
 import TEXT27_XIV from '@/components/Text/27_XIV'
 import TEXT28_CONSEQUENTIALDATA from '@/components/Text/28_consequentialdata'
 import TEXT29_SCOBIES from '@/components/Text/29_scobies'
 import TEXT30_WORKPOINT from '@/components/Text/30_workpoint'
 import TEXT31_NOTE from '@/components/Text/31_note'
 import TEXT32_SECTION03 from '@/components/Text/32_section03'
 import TEXT33_DEDICAT from '@/components/Text/33_dedicat'
 import TEXT34_NOTE from '@/components/Text/34_note'
 import TEXT35_SERIES from '@/components/Text/35_series'
 import TEXT36_I from '@/components/Text/36_I'
 import TEXT37_II from '@/components/Text/37_II'
 import TEXT38_III from '@/components/Text/38_III'
 import TEXT39_IV from '@/components/Text/39_IV'
 import TEXT40_V from '@/components/Text/40_V'
 import TEXT41_VI from '@/components/Text/41_VI'
 import TEXT42_VII from '@/components/Text/42_VII'
 import TEXT43_VIII from '@/components/Text/43_VIII'
 import TEXT44_IX from '@/components/Text/44_IX'
 import TEXT45_X from '@/components/Text/45_X'
 import TEXT46_XI from '@/components/Text/46_XI'
 import TEXT47_XII from '@/components/Text/47_XII'
 import TEXT48_XIII from '@/components/Text/48_XIII'
 import TEXT49_XIV from '@/components/Text/49_XIV'
 import TEXT50_XV from '@/components/Text/50_XV'
 import TEXT51_XVI from '@/components/Text/51_XVI'
 import TEXT52_SECTION04 from '@/components/Text/52_section04'
 import TEXT53_DEDICAT from '@/components/Text/53_dedicat'
 import TEXT54_SERIES from '@/components/Text/54_series'
 import TEXT55_I from '@/components/Text/55_I'
 import TEXT56_II from '@/components/Text/56_II'
 import TEXT57_III from '@/components/Text/57_III'
 import TEXT58_IV from '@/components/Text/58_IV'
 import TEXT59_V from '@/components/Text/59_V'
 import TEXT60_II from '@/components/Text/60_II'
 import TEXT61_III from '@/components/Text/61_III'
 import TEXT62_IV from '@/components/Text/62_IV'
 import TEXT63_V from '@/components/Text/63_V'
 import TEXT64_VI from '@/components/Text/64_VI'
 import TEXT65_VII from '@/components/Text/65_VII'
 import TEXT66_VIII from '@/components/Text/66_VIII'
 import TEXT67_1X from '@/components/Text/67_1X'
 import TEXT68_X from '@/components/Text/68_X'
 import TEXT69_WORKPOINT from '@/components/Text/69_workpoint'
 import TEXT70_SOME from '@/components/Text/70_some'
 import TEXT72_NOTES from '@/components/Text/72_notes'
 import TEXTLOVE1 from '@/components/Text/love1'
 import TEXTBIOGRAPHY from '@/components/Text/biography'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/introduction",
 			"name" : "Text/introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/01_section",
 			"name" : "Text/01_section",
 			"component" : TEXT01_SECTION
 		},
 		{
 			"path" : "/Text/02_note",
 			"name" : "Text/02_note",
 			"component" : TEXT02_NOTE
 		},
 		{
 			"path" : "/Text/03_series",
 			"name" : "Text/03_series",
 			"component" : TEXT03_SERIES
 		},
 		{
 			"path" : "/Text/04_ded",
 			"name" : "Text/04_ded",
 			"component" : TEXT04_DED
 		},
 		{
 			"path" : "/Text/05_part1",
 			"name" : "Text/05_part1",
 			"component" : TEXT05_PART1
 		},
 		{
 			"path" : "/Text/06_part2",
 			"name" : "Text/06_part2",
 			"component" : TEXT06_PART2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js